import React from "react";
import Message from "assets/scripts/components/common/Message/Message";
const Link = ({ href, text, targetSelf }) => (<a className="link" href={href} target={targetSelf ? undefined : "_blank"} rel={targetSelf ? undefined : "noopener noreferrer"}>
		{text === undefined ? href : (<Message value={text}/>)}
	</a>);
export default Link;



// WEBPACK FOOTER //
// ./src/assets/scripts/components/containers/public/legal/Link/Link.tsx